<div [formGroup]="formGroup">
  <cap-input formControlName="answer_text"></cap-input>
</div>
